import React, { useEffect, useState } from 'react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [showIosInstructions, setShowIosInstructions] = useState(false);

  useEffect(() => {
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

    if (isIos && !isInStandaloneMode) {
      setShowIosInstructions(true);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    console.log('Instalación:', result.outcome);
    setDeferredPrompt(null);
    setShowInstallButton(false);
  };

  return (
    <div style={{ padding: '1rem' }}>
      {showInstallButton && (
        <button onClick={handleInstallClick} style={{ padding: '10px 20px' }}>
          Instalar aplicación
        </button>
      )}

      {showIosInstructions && (
        <div style={{ fontSize: 14, maxWidth: 300 }}>
          Para instalar esta app, abre el menú de Safari (
          <span style={{ fontWeight: 'bold' }}>'Compartir'</span>) y selecciona{' '}
          <span style={{ fontWeight: 'bold' }}>'Agregar a pantalla de inicio'</span>.
        </div>
      )}
    </div>
  );
};

export default InstallPrompt;